import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { HttpService } from '../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class ListaAlteracaoStatusService {

  constructor(private http:HttpService,  private httpService:HttpService) { }

  buscaUsuario(data: any, successHandle:Function, errorHandle:Function) {

    this.http.doGet('/employee/product/details', data, successHandle, errorHandle);

 }

 saveAlterStatus(data:any, successHandle:Function, errorHandle:Function){
  return this.httpService.doPost('/employee/product/alterStatus',data,successHandle, errorHandle);
}



}
